export default __webpack_public_path__ + "static/All-6614dd39bc9aa9321bbd6b67770d59e4.mp4";